// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legal-information[data-v-79f3e950]{display:grid;grid-gap:2rem;gap:2rem;margin-top:100px}.legal-information__content[data-v-79f3e950]{display:grid;grid-gap:.7rem;gap:.7rem}.legal-information__content p[data-v-79f3e950]{margin:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
